import React from "react";

export default function RadioField({ label, checked = false }: { label: string; checked?: boolean }) {
  return (
    <div className='tw-flex tw-gap-4'>
      <span
        className={`tw-flex tw-h-6 tw-w-6 tw-rounded-full tw-border-2 tw-border-solid tw-border-[var(--radio-color)]`}
        style={{ "--radio-color": checked ? "#4286DE" : "#6D6D6D" } as React.CSSProperties}
      >
        {checked && <span className='tw-m-auto tw-h-3 tw-w-3 tw-rounded-full tw-bg-[var(--radio-color)]' />}
      </span>

      <span className='tw-text-xl'>{label}</span>
    </div>
  );
}
